import React from "react";

import { MenuItemVariantOffer } from "@/custom-types/MenuItem";

import { default as DumbOffers } from "./Offers";
import { default as DumbOffersModal } from "./OffersModal";

type Props = {
  buttonRef: React.MutableRefObject<null>;
  dispensarySlug: string;
  offers: MenuItemVariantOffer[];
  setModalIsVisible: (isVisible: boolean) => void;
};

const Offers: React.FC<Props> = ({
  buttonRef,
  dispensarySlug,
  offers,
  setModalIsVisible,
}) => {
  if (!offers || offers.length === 0) {
    return null;
  }

  return (
    <DumbOffers
      offers={offers}
      dispensarySlug={dispensarySlug}
      setModalIsVisible={setModalIsVisible}
      buttonRef={buttonRef}
    />
  );
};

const OffersModal: React.FC<Props> = ({
  buttonRef,
  dispensarySlug,
  offers,
  setModalIsVisible,
}) => (
  <DumbOffersModal
    offers={offers}
    dispensarySlug={dispensarySlug}
    setModalIsVisible={setModalIsVisible}
    buttonRef={buttonRef}
  />
);

export { Offers, OffersModal };
